<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'user.detail', params: {id: id}}">Сотрудник</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'user.list'}">Сотрудники</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>

          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активный"/>
          <gui-input v-model="data.name" :error="dataError.name" label="Имя"/>
          <gui-input v-model="data.email" :error="dataError.email" label="Email"/>
          <gui-role-multi-select v-model="data.role_ids" :error="dataError.role_ids" label="Роль"/>
          <gui-date-time v-model="data.email_verified_at" :error="dataError.email_verified_at"
                         label="Дата подтверждения почты"/>
          <gui-input v-model="data.password" :error="dataError.password" label="Новый пароль"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


import GuiRoleMultiSelect from "@/components/Widget/GuiRoleMultiSelect";

export default {
  components: {GuiRoleMultiSelect},
  data() {
    return {
      data: null,
      dataDefault: {
        name: '',
        email: '',
        email_verified_at: '',
        is_active: '',
        password: '',
        role_ids: [],
      },
      dataError: {
        name: '',
        email: '',
        email_verified_at: '',
        is_active: '',
        password: '',
        role_ids: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/user/get', {id: this.id}, e => {
        this.data = e
        this.data.role_ids = e.roles.map(e => e.id)
      }, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/user/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'user.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/user/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'user.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>